/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CouponModel from 'cio/models/coupon';
import SubscriptionModel from 'cio/models/subscription';

interface SettingsSubscriptionStartupProgramAlertArgs {
  isStartupPlan: boolean;
  coupon?: CouponModel;
  planName: string;
  subscription: SubscriptionModel;
}

export default class SettingsSubscriptionStartupProgramAlert extends Component<SettingsSubscriptionStartupProgramAlertArgs> {
  get amountOff() {
    let {
      coupon,
      subscription: { plan },
    } = this.args;

    if (!coupon) {
      return 0;
    }

    if (coupon.amountOff) {
      return coupon.amountOff;
    } else {
      let price;

      if (plan.get('annual')) {
        price = plan.get('monthlyPriceIfPaidAnnually') ?? plan.get('price');
      } else {
        price = plan.get('price');
      }

      return price * (coupon.percentOff / 100);
    }
  }
}
